import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Check, X, Filter, Search } from 'lucide-react';
type TabType = 'all' | 'contracts' | 'payouts' | 'outreach' | 'claims';
export function AdminApprovalsPage() {
  const [activeTab, setActiveTab] = useState<TabType>('all');
  return <div className="min-h-screen bg-background text-textMain flex flex-col" data-id="element-683">
      <header className="h-16 border-b border-border flex items-center justify-between px-6 bg-surface shrink-0" data-id="element-684">
        <div className="flex items-center gap-4" data-id="element-685">
          <span className="text-xl font-bold text-red-500" data-id="element-686">Booker Admin</span>
          <div className="w-px h-6 bg-border" data-id="element-687"></div>
          <nav className="flex items-center gap-4 text-sm font-medium" data-id="element-688">
            <Link to="/admin" className="text-textMuted hover:text-textMain" data-id="element-689">
              Dashboard
            </Link>
            <Link to="/admin/approvals" className="text-textMain" data-id="element-690">
              Approvals
            </Link>
            <Link to="/admin/audit-log" className="text-textMuted hover:text-textMain" data-id="element-691">
              Audit Log
            </Link>
          </nav>
        </div>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex-1 p-8 max-w-7xl mx-auto w-full" data-id="element-692">
        <div className="mb-8" data-id="element-693">
          <h1 className="text-2xl font-bold mb-1" data-id="element-694">Approvals Queue</h1>
          <p className="text-sm text-textMuted" data-id="element-695">
            Centralized queue for high-risk actions awaiting review.
          </p>
        </div>

        <div className="flex gap-6 border-b border-border mb-6 overflow-x-auto" data-id="element-696">
          {(['all', 'contracts', 'payouts', 'outreach', 'claims'] as TabType[]).map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-3 text-sm font-medium transition-colors whitespace-nowrap capitalize ${activeTab === tab ? 'text-primary border-b-2 border-primary' : 'text-textMuted hover:text-textMain'}`} data-id="element-697">
              {tab}
            </button>)}
        </div>

        <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-698">
          <div className="p-4 border-b border-border flex items-center justify-between" data-id="element-699">
            <div className="relative w-64" data-id="element-700">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-textMuted" data-id="element-701" />
              <input type="text" placeholder="Search requests..." className="w-full pl-9 pr-4 py-2 bg-background border border-border rounded-lg text-sm focus:outline-none focus:border-primary" data-id="element-702" />
            </div>
            <button className="px-3 py-1.5 bg-background border border-border rounded-lg text-sm flex items-center gap-2 hover:bg-surfaceHover" data-id="element-703">
              <Filter className="w-4 h-4" data-id="element-704" /> Filter
            </button>
          </div>
          <table className="w-full text-sm text-left" data-id="element-705">
            <thead className="text-xs text-textMuted uppercase bg-background/50 border-b border-border" data-id="element-706">
              <tr data-id="element-707">
                <th className="px-6 py-4 font-medium" data-id="element-708">Request Type</th>
                <th className="px-6 py-4 font-medium" data-id="element-709">Requested By</th>
                <th className="px-6 py-4 font-medium" data-id="element-710">Details</th>
                <th className="px-6 py-4 font-medium" data-id="element-711">Time</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-712">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border" data-id="element-713">
              {[{
              type: 'Payout Batch',
              user: 'Mark Johnson',
              details: '$2,350.00 to 4 members',
              time: '2h ago'
            }, {
              type: 'Venue Claim',
              user: 'Brent Heyl',
              details: 'The Empty Bottle (Chicago)',
              time: '5h ago'
            }, {
              type: 'Outreach Blast',
              user: 'Emma Davis',
              details: 'Sending to 150 targets (Exceeds limit)',
              time: '1d ago'
            }, {
              type: 'Contract Template',
              user: 'Legal Team',
              details: 'Updated Force Majeure clause',
              time: '1d ago'
            }].map((req, i) => <tr key={i} className="hover:bg-surfaceHover/50 transition-colors" data-id="element-714">
                  <td className="px-6 py-4 font-medium" data-id="element-715">{req.type}</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-716">{req.user}</td>
                  <td className="px-6 py-4" data-id="element-717">{req.details}</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-718">{req.time}</td>
                  <td className="px-6 py-4 text-right" data-id="element-719">
                    <div className="flex items-center justify-end gap-2" data-id="element-720">
                      <button className="p-1.5 bg-green-500/10 text-green-500 hover:bg-green-500/20 rounded transition-colors" data-id="element-721">
                        <Check className="w-4 h-4" data-id="element-722" />
                      </button>
                      <button className="p-1.5 bg-red-500/10 text-red-500 hover:bg-red-500/20 rounded transition-colors" data-id="element-723">
                        <X className="w-4 h-4" data-id="element-724" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </motion.div>
    </div>;
}